import React from 'react'
import Guards from './Guards'

function GuardCheckIn(props) {
  return (
    <Guards {...props} isCheckIn={true}/>
  )
}

export default GuardCheckIn